import React from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import moment from 'moment';
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  tableStyle: {
    border: "none",
    boxShadow: "none",
  },
  tableText: {
    fontFamily: "Open Sans",
    fontWeight: 'normal',
    fontSize: "12px",
    lineHeight: "16px",
    color: "#141414",
    textAlign: "center",
    margin: "10px",
    padding: "6px",
    minWidth: "120px"
  },
  tableHeader: {
    textAlign: "center",
    fontFamily: "Open Sans",
    fontStyle: "normal",
    fontWeight: "normal",
    color: '#6F6F6F',
    fontSize: "14px",
    lineHeight: "19px",
    padding: "6px",
  },
  even: {
    background: "#F3F3F3",
  },
  odd: {
    background: "#FFFFFF",
  },
}));

function PEPTable(props) {
  const { t } = useTranslation();

  const classes = useStyles();
  useTheme();

  const getClass = (rowIndex) => {
    if (rowIndex % 2 === 0) {
      return classes.even;
    }

    return classes.odd;
  };

  return (
    <Paper className={classes.tableStyle}>
      <Table style={{ padding: "8px" }}>
        <TableHead>
          <TableRow>
            <TableCell className={classes.tableHeader}>{t("role_description")}</TableCell>
            <TableCell className={classes.tableHeader}>{t("mandate_start_date")}</TableCell>
            <TableCell className={classes.tableHeader}>{t("mandate_end_date")}</TableCell>
            <TableCell className={classes.tableHeader}>{t("listing_end_date")}</TableCell>
            <TableCell className={classes.tableHeader}>{t("agency_name")}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.pep_data.map((mandate,index) => (
            <TableRow
              key={index}
              className={getClass(index)}
            >
              <TableCell style={{whiteSpace:"nowrap"}} className={classes.tableText}>
                {mandate.role_description}
              </TableCell>
              <TableCell className={classes.tableText}>
                {mandate.mandate_start_date == null ? "-" : moment(mandate.mandate_start_date).format('DD/MM/YYYY')}
              </TableCell>
              <TableCell className={classes.tableText}>
                {mandate.mandate_end_date == null ? "-" : moment(mandate.mandate_end_date).format('DD/MM/YYYY')}
              </TableCell>
              <TableCell className={classes.tableText}>
                {mandate.listing_end_date == null ? "-" : moment(mandate.listing_end_date).format('DD/MM/YYYY')}
              </TableCell>
              <TableCell className={classes.tableText}>
                {mandate.agency_name == null ? "-" : mandate.uf == null ? mandate.agency_name : 
                  mandate.agency_name + " - "+ mandate.uf}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
}

export default PEPTable;
